// extracted by mini-css-extract-plugin
export default {"container":"TextEditor_container__jZ51x","hideToolbar":"TextEditor_hideToolbar__zgGtM"};